/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CheckInAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import AssignConnection from './AssignConnection/index'
import Children from 'Simple/Children'
import Confirmation from './Confirmation/index'
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function CheckInAction({
  children,
  viewPath = "/DesignSystem/CheckInAction",
  onClick,
  onSubmit,
  isSubmitting,
  isSelected
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let checkInSubmitData = fromData.useDataSubmit({ viewPath,
context: 'check_in',
})
let checkInIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'check_in',
})
  return (<React.Fragment
>
<button
  data-testid="CheckInAction.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 className={`views-block ${styles.Vertical}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 data="check_in"
 onClick={checkInSubmitData}
 disabled={checkInIsSubmittingData}
 isSelected={isSelected} isHovered={isHovered} isSelectedHovered={isSelectedHovered}
>
{children}
</Children>
<AssignConnection
  viewPath={`${viewPath}/AssignConnection`}
/>
<Confirmation
  viewPath={`${viewPath}/Confirmation`}
/>
</button>
</React.Fragment>)
}